import { Space } from 'antd';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { IconTemplate } from '@tabler/icons-react';

import Order from './Order';
import Renew from './Renew';
import Deploy from './Deploy';
import GetList from './GetList';
import Document from '../Document';
import RenewInfo from './RenewInfo';
import router from '~/configs/routes';
import OrderDetail from './OrderDetail';

function Template() {
    return (
        <Fragment>
            <Helmet>
                <title>Thegioicode.com - API tạo website</title>
                <meta
                    key="description"
                    name="description"
                    content="API document này giúp lấy danh sách mẫu website khởi tạo website và quản lý dịch vụ website đã khởi tạo"
                />

                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={`https://thegioicode.com${router.document}`} />
                <meta property="og:url" content={`https://thegioicode.com${router.document}`} />
                <meta property="og:title" content="Thegioicode.com - API tạo website" />
                <meta property="og:image" content="https://thegioicode.com/images/izgdwacbGc.png" />
                <meta
                    property="og:description"
                    content="API document này giúp lấy danh sách mẫu website khởi tạo website và quản lý dịch vụ website đã khởi tạo"
                />
            </Helmet>

            <Document
                keyTab="4"
                label={
                    <span className="box-align-center gap-2 text-subtitle">
                        <IconTemplate width={20} height={20} />
                        Tạo website
                    </span>
                }
            >
                <div className="api-detail">
                    <Space direction="vertical" className="w-full">
                        <GetList />

                        <Deploy />

                        <Order />

                        <OrderDetail />

                        <RenewInfo />

                        <Renew />
                    </Space>
                </div>
            </Document>
        </Fragment>
    );
}

export default Template;
